export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = import.meta.env.VITE_PUBLIC_BASE_HOME|| '/dashboard',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  // webrtc
  WEBRTC_BROADCAST = '/demos/webrtc/broadcast',
  WEBRTC_VIEW = '/demos/webrtc/view',
}
export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight';
